import { useState } from 'react';
import { AlertTriangle, X } from 'lucide-react';
import api from '../../services/api';

const ImpersonateBanner = () => {
    const [isLoading, setIsLoading] = useState(false);
    const isImpersonating = localStorage.getItem('isImpersonating') === 'true';

    if (!isImpersonating) {
        return null;
    }

    const handleStopImpersonating = async () => {
        setIsLoading(true);

        try {
            // Chama a API para parar o impersonate
            await api.post('/api/admin/impersonate/stop');
        } catch (error) {
            console.error('Erro ao parar impersonate:', error);
        } finally {
            // Remove os dados do localStorage independente do resultado da API
            localStorage.removeItem('token');
            localStorage.removeItem('isImpersonating');
            localStorage.removeItem('user');

            // Redireciona para o painel admin
            const adminPanelUrl = import.meta.env.VITE_ADMIN_PANEL_URL || 'https://backoffice.sellyo.com.br';
            window.location.href = `${adminPanelUrl}/companies`;
        }
    };

    return (
        <div className="bg-yellow-400 border-b-2 border-yellow-500 w-full sticky top-0 z-[999992]">
            <div className="px-4 py-3">
                <div className="flex items-center justify-between flex-wrap gap-2">
                    <div className="flex items-center gap-3">
                        <AlertTriangle className="h-5 w-5 text-yellow-900" />
                        <span className="text-sm font-semibold text-yellow-900">
                            Você está visualizando como administrador
                        </span>
                    </div>

                    <button
                        onClick={handleStopImpersonating}
                        disabled={isLoading}
                        className="flex items-center gap-2 px-4 py-2 bg-yellow-900 text-white rounded-md hover:bg-yellow-800 transition-colors disabled:opacity-50 disabled:cursor-not-allowed text-sm font-medium"
                    >
                        {isLoading ? (
                            <>
                                <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white"></div>
                                <span>Saindo...</span>
                            </>
                        ) : (
                            <>
                                <X className="h-4 w-4" />
                                <span>Voltar ao Painel Admin</span>
                            </>
                        )}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ImpersonateBanner;
